import React, { useState } from "react"

function Footer() {

  const [sections] = useState([
    {
      name: "Services", items: [
        { name: "Stox Reader", url: "/stox" },
        { name: "Igramscraper", url: "/#igramscraper" },
      ]
    },
    {
      name: "Legal", items: [
        { name: "Privacy", url: "/privacy" },
        { name: "Terms", url: "/terms" },
      ]
    }
  ])
  return (

    <footer class="py-8 py-md-11 bg-gray-200">
      <div class="container">
        <div class="row">
          <div class="col-9 col-md-4 col-lg-3">
            <h1 class="display-3 text-center text-md-left" style={{fontSize: '2.5rem'}}>
                <span style={{ color: '#335eea', fontWeight: 'bold' }}>Delta</span> Parse
              </h1>
            <p class="text-gray-700 mb-2">
                Our Mission is to organize the Worlds Information
            </p>
            <br/>
          </div>
          {sections.map(section => (
            <div class="col-6 col-md-4 col-lg-2">
              <h6 class="font-weight-bold text-uppercase text-gray-700">{section.name}</h6>
              <ul class="list-unstyled text-muted mb-6 mb-md-8 mb-lg-0">
                {section.items.map(item => (
                  <li class="mb-3">
                    <a href={item.url} class="text-reset">{item.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
  )
}

export default Footer
